import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Footer } from 'containers/layout'
import { apiConfiguration } from 'helpers/decorators/api'

@apiConfiguration({
  keys: true
})
class SettingsNaoDetails extends Component {
  static propTypes = {
    configuration: PropTypes.object.isRequired
  }

  render() {
    const { configuration } = this.props
    let configKeys = []

    for (const key in configuration.values) {
      if (configuration.values.hasOwnProperty(key)) {
        configKeys = configKeys.concat(configuration.values[key])
      }
    }

    return (
      <div>
        {configKeys.map(configKey => (
          <div key={configKey.id}>
            {configKey.configurationKey.description}
            {' '}
            <strong>{String(configKey.booleanValue)}</strong>
          </div>
        ))}
        <Footer />
      </div>
    )
  }
}

export default SettingsNaoDetails
